import { render, staticRenderFns } from "./chhosewechatqiwei.vue?vue&type=template&id=ac22376e&scoped=true"
import script from "./chhosewechatqiwei.vue?vue&type=script&lang=js"
export * from "./chhosewechatqiwei.vue?vue&type=script&lang=js"
import style0 from "./chhosewechatqiwei.vue?vue&type=style&index=0&id=ac22376e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac22376e",
  null
  
)

export default component.exports